var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeCcBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M59,6H54V2.092a4.261,4.261,0,0,0-.022-1.3A1,1,0,0,0,52,1V1.98a3.168,3.168,0,0,1-.7,1.485C50.339,4.622,48,6,42.3,6H1A1,1,0,0,0,0,7V39a1,1,0,0,0,1,1H59a1,1,0,0,0,1-1V7A1,1,0,0,0,59,6ZM58,8V22H54V8ZM52,5.569V17.056a3.529,3.529,0,0,1-1.133,2.314C49.688,20.57,47.071,22,41.3,22H19.95a5.873,5.873,0,0,0,1.064-.827,4.375,4.375,0,0,0-6.188-6.187,5.538,5.538,0,0,0-.531.634V8h28C46.784,8,50.039,7.185,52,5.569ZM19.6,25.946a2.376,2.376,0,0,1-3.291,3.427c-.023-.022-.045-.044-.067-.067-1.131-1.133-1.7-3.48-1.945-5.137V24h.164C16.117,24.246,18.468,24.814,19.6,25.946Zm-12.9,0c1.133-1.132,3.485-1.7,5.142-1.945h.191c-.231,1.66-.8,4.132-1.974,5.305A2.376,2.376,0,0,1,6.7,25.946Zm7.6-4.215v-.2c.245-1.654.812-3.994,1.945-5.128a2.376,2.376,0,0,1,3.359,3.36C18.431,20.928,15.958,21.5,14.3,21.731ZM6.7,19.76a2.376,2.376,0,0,1,3.359-3.36c1.176,1.177,1.748,3.675,1.977,5.337C10.371,21.51,7.875,20.939,6.7,19.76ZM12.3,8v8.05a5.931,5.931,0,0,0-.828-1.065,4.375,4.375,0,1,0-6.187,6.187A5.972,5.972,0,0,0,6.345,22H2V8H12.3ZM2,24H5.915a5.537,5.537,0,0,0-.634.531,4.376,4.376,0,0,0,6.188,6.188h0a5.931,5.931,0,0,0,.828-1.065V38H2ZM39.3,38h-25V30.086a5.537,5.537,0,0,0,.531.634,4.376,4.376,0,0,0,6.188-6.188h0A5.568,5.568,0,0,0,20.382,24H42.3v-.027c4.452-.129,7.71-1.119,9.7-2.949V32.582a1.012,1.012,0,0,1-.116.47l-.139.277C50.993,34.846,49.429,38,42.3,38h-3Zm11.079,0a9.04,9.04,0,0,0,3.162-3.783l.125-.25A3.011,3.011,0,0,0,54,32.582V24h4V38H50.379Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(37.296 32.001)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(41.296 32.001)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-1",
    width: 11,
    height: 2,
    transform: "translate(24.296 32.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCcBlanc);
export default __webpack_public_path__ + "static/media/icone_cc-blanc.9514588483789ad3a927d9699c720ecf.svg";
export { ForwardRef as ReactComponent };